import React from 'react';
import { Package } from 'lucide-react';

// OrdersHistoryScreen (Meus pedidos) do cardápio público. Extraído VERBATIM de
// PublicMenu.js (Fase 2 refactor). Renderizado como <OrdersHistoryScreen .../>,
// recebe estado/handlers do pai via props.
const OrdersHistoryScreen = ({ customerPhone, orderHistory, setSelectedOrderDetails, handleReorder }) => {
    const formatDate = (dateStr) => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };
    
    const formatTime = (dateStr) => {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    };
    
    const getStatusColor = (status) => {
      const colors = {
        'preparando': 'bg-primary',
        'pronto': 'bg-green-500',
        'entregue': 'bg-gray-500',
        'cancelado': 'bg-red-500'
      };
      return colors[status] || 'bg-gray-500';
    };
    
    const getStatusLabel = (status, deliveryType = 'delivery') => {
      // Para status 'entrega', diferenciar entre delivery e retirada
      if (status === 'entrega') {
        if (deliveryType === 'retirada' || deliveryType === 'pickup') {
          return 'Pronto p/ Retirada';
        }
        return 'Saiu p/ Entrega';
      }
      
      // Para status 'pronto', diferenciar entre delivery e retirada
      if (status === 'pronto' || status === 'entregue') {
        if (deliveryType === 'retirada' || deliveryType === 'pickup') {
          return 'Retirado';
        }
        return 'Entregue';
      }
      
      const labels = {
        'pendente': 'Pendente',
        'em_producao': 'Em Produção',
        'preparando': 'Preparando',
        'cancelado': 'Cancelado'
      };
      return labels[status] || status;
    };

    return (
      <div 
        className="pt-16 pb-20 h-screen overflow-y-auto bg-gray-50"
        data-testid="orders-history-screen"
      >
        <div className="p-4 space-y-4">
          {/* Header */}
          <div className="text-center mb-2">
            <h2 className="text-xl font-bold text-gray-800">Meus pedidos</h2>
          </div>

          {!customerPhone || !orderHistory || orderHistory.length === 0 ? (
            <div className="text-center py-12">
              <Package className="mx-auto text-gray-400 mb-4" size={64} />
              <p className="text-gray-600 mb-2">Nenhum pedido encontrado</p>
              <p className="text-sm text-gray-500">
                {!customerPhone 
                  ? 'Faça seu primeiro pedido para ver o histórico aqui'
                  : 'Você ainda não fez nenhum pedido'}
              </p>
            </div>
          ) : (
            orderHistory.map((order) => (
              <div 
                key={order.id} 
                className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
                data-testid={`order-card-${order.order_number}`}
              >
                {/* Order Header */}
                <div className="p-4 border-b border-gray-100">
                  <div className="flex items-center justify-between mb-2">
                    <div>
                      <h3 className="font-bold text-gray-800">Pedido #{order.order_number}</h3>
                      <p className="text-sm text-gray-500">
                        Em {formatDate(order.created_at)} às {formatTime(order.created_at)}
                      </p>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-white text-xs font-medium ${getStatusColor(order.status)}`}>
                      {getStatusLabel(order.status, order.delivery_type)}
                    </span>
                  </div>
                  
                  {/* Items List */}
                  <div className="mt-3 space-y-1">
                    {order.items && order.items.map((item, idx) => (
                      <div key={idx} className="text-sm text-gray-600">
                        {item.quantity}x {item.product_name}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Order Footer */}
                <div className="p-4 bg-gray-50">
                  <div className="flex items-center justify-between">
                    <span className="text-xl font-bold text-gray-800">
                      R$ {order.total?.toFixed(2) || '0.00'}
                    </span>
                    <div className="flex gap-2">
                      <button 
                        className="px-4 py-2 border border-primary text-primary rounded-lg text-sm font-medium hover:bg-primary-light transition-colors"
                        onClick={() => setSelectedOrderDetails(order)}
                        data-testid={`order-details-btn-${order.order_number}`}
                      >
                        Detalhes do pedido
                      </button>
                      <button 
                        className="px-4 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary-hover transition-colors"
                        onClick={() => handleReorder(order)}
                        data-testid={`reorder-btn-${order.order_number}`}
                      >
                        Repetir pedido
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
};

export default OrdersHistoryScreen;
